module.exports = __webpack_public_path__ + "img/banner-40.76c2da34.jpg";